<template>
    <div :class="{ 'no-marq': !toggler.isOpen() }"></div>
</template>

<script setup>
    const toggler = ToggleStore().toggler("marq");
</script>
